import React from 'react'
import styles from './styles.scss'

export const SiderLogoContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    
    return (
        <div className={styles.root}>
            {children}
        </div>
    )
}
